export function humburger() {
  const menuTrigger = document.querySelector('.js-menu-trigger');
  const header = document.querySelector('.l-header');
  const menu = document.querySelector('.l-header__menu');
  const dropdownToggles = document.querySelectorAll('.js-header-dropdown-toggle');
  const overlay = document.querySelector('.menu-overlay');

  // メニューを開閉する関数
  function toggleMenu() {
    const isOpen = header.classList.toggle('is-menu-open');
    menuTrigger.classList.toggle('is-menu-open', isOpen);
    overlay.classList.toggle('is-visible', isOpen);

    // メニューが閉じるとき、ドロップダウンも閉じる
    if (!isOpen) {
      document.querySelectorAll('.l-header__dropdown.is-open').forEach(dropdown => {
        dropdown.classList.remove('is-open');
        dropdown.style.maxHeight = '0';
      });
    }
  }

  // ドロップダウンを開閉する関数
  function toggleDropdown(dropdownMenu) {
    const isOpen = dropdownMenu.classList.contains('is-open');

    // 他の開いているドロップダウンを閉じる
    document.querySelectorAll('.l-header__dropdown.is-open').forEach(menu => {
      menu.classList.remove('is-open');
      menu.style.maxHeight = '0';
    });

    // 現在のドロップダウンを開く
    if (!isOpen) {
      dropdownMenu.classList.add('is-open');
      dropdownMenu.style.maxHeight = dropdownMenu.scrollHeight + 'px';
    }
  }

  // トリガーボタンをクリックしたとき
  menuTrigger.addEventListener('click', (e) => {
    e.stopPropagation(); // クリックイベントが他に伝播しないようにする
    toggleMenu();
  });

  // ドロップダウントグルのクリック処理
  dropdownToggles.forEach(toggle => {
    toggle.addEventListener('click', (e) => {
      e.preventDefault(); // デフォルトのリンク動作を無効化
      const dropdownId = toggle.getAttribute('data-dropdown');
      const dropdownMenu = document.getElementById(dropdownId); // 対応するサブメニューを取得
      toggleDropdown(dropdownMenu);
    });
  });

  // メニュー外をクリックしたとき
  document.addEventListener('click', (e) => {
    if (!menu.contains(e.target) && !menuTrigger.contains(e.target)) {
      if (header.classList.contains('is-menu-open')) {
        toggleMenu();
      }
      document.querySelectorAll('.l-header__dropdown.is-open').forEach(menu => {
        menu.classList.remove('is-open');
        menu.style.maxHeight = '0';
      });
    }
  });
}
